

export function setPageWechatConfig(pageConfig) {
    pageConfig.shareCourse.wechatConfig = {
        shareTitle:'', // 分享标题
        shareDesc:'', // 分享描述
        shareUrl: window.location.href, // 分享链接
        shareImg: 'http://p.hulian120.com/share/app_share_icon.png', // 分享图标
    };
    pageConfig.shareCourseSettle.wechatConfig = {
        shareTitle:'', // 分享标题
        shareDesc:'', // 分享描述
        shareUrl: window.location.href, // 分享链接
        shareImg: 'http://p.hulian120.com/share/app_share_icon.png', // 分享图标
    };
    pageConfig.shareArticle.wechatConfig = {
        shareTitle:'', // 分享标题
        shareDesc:'', // 分享描述
        shareUrl: window.location.href, // 分享链接
        shareImg: 'http://p.hulian120.com/share/app_share_icon.png', // 分享图标
    };
    pageConfig.shareOrder.wechatConfig = {
        shareTitle:'', // 分享标题
        shareDesc:'', // 分享描述
        shareUrl: window.location.href, // 分享链接
        shareImg: 'http://p.hulian120.com/share/app_share_icon.png', // 分享图标
    };
    pageConfig.shareStudio.wechatConfig = {
        shareTitle:'', // 分享标题
        shareDesc:'', // 分享描述
        shareUrl: window.location.href, // 分享链接
        shareImg: 'http://p.hulian120.com/share/app_share_icon.png', // 分享图标
    };
    pageConfig.shareCourseAudition.wechatConfig = {
        shareTitle:'', // 分享标题
        shareDesc:'', // 分享描述
        shareUrl: window.location.href, // 分享链接
        shareImg: 'http://p.hulian120.com/share/app_share_icon.png', // 分享图标
    };
    pageConfig.autoLogin.wechatConfig = {
        shareTitle:'', // 分享标题
        shareDesc:'', // 分享描述
        shareUrl: "", // 分享链接
        shareImg: "", // 分享图标
    };
}
